module.exports = __webpack_public_path__ + "static/media/background.703ea13d.png";